const ENIndicators = {
	"Abrir Indicador": "Open Indicator",
	"Cadastro de indicadores": "Register indicators",
	"Campos de indicador": "Indicator's field",
	"Novo indicador":"New indicator",
	"Exclusão de Indicador":"Delete indicator",
	"Deseja realmente excluir o indicador":"Do you really want to delete the indicator",
	"Digite o nome do indicador para excluí-lo":"Enter the name of the indicator to delete it.",
	"Indicador excluído com sucesso":"Indicator successfully deleted",
	"Erro ao excluir indicador":"Error on delete indicator",
	"Titulo do indicador não confere":"Indicator title doesn't match",
	"Painel de apresentação": "Presentation panel"
};

export default ENIndicators;
